import React from 'react'


const SalesQuantityReportPDFDocument = React.forwardRef(({ salesDetails, grandNetTotal, grandNetTotalQuantity, formData, userInfo }, ref) => (

  <div ref={ref} className="p-6">
    {/* Header */}
    <div className="flex justify-between items-center mb-4 border-b-2 border-black pb-2">
        {/* First Column: Title and Date Range */}
        <div>
          <h1 className="font-bold text-sm">Sales Quantity Report</h1>
          {/* <p className="text-xs text-gray-600">{`${formData.start_date} to ${formData.end_date}`}</p> */}
          <p className="text-xs text-gray-600">{`${new Date(formData.start_date).toLocaleDateString('en-GB')} to ${new Date(formData.end_date).toLocaleDateString('en-GB')}`}</p>
        </div>

        {/* Second Column: Shop Details */}
        <div className="text-right">
          <p className="text-lg font-bold">{userInfo?.outlet_name}</p>
          <p className="text-xs text-gray-600">{userInfo?.address}</p>
          <p className="text-xs text-gray-600">Mobile- {userInfo?.phone}</p>
        </div>
    </div>
    {/* Table */}
    <div className="overflow-x-auto">
      <table className="table-auto w-full border-collapse border border-gray-400">
        {/* Table Head */}
        <thead>
          <tr style={{ backgroundColor: "#f5f5f5", border: "2px solid black" }}>
            <th className="px-2 text-left text-xs">Product</th>
            <th className="px-2 text-center text-xs">Price</th>
            <th className="px-2 text-center text-xs">Quantity</th>
            <th className="px-2 text-right text-xs">
              <div>
                <span>Sales Amount</span>
                <br />
                <span className="text-xs">(In BDT)</span>
              </div>
            </th>
          </tr>
        </thead>

        {/* Table Body */}
        <tbody>
          {salesDetails.map((detail, index) => (
            <tr key={index} className="hover:bg-gray-100 border border-gray-400">
              <td className="text-xs px-2 text-left">
                {detail?.product_info?.name || "N/A"}
              </td>
              <td className="text-xs px-2 text-center">
                {detail?.single_price || "0"}
              </td>
              <td className="text-xs px-2 text-center">
                {detail?.qty_sum || "0"}
              </td>
              <td className="text-xs px-2 text-right">
                {detail?.price_sum || "0"}
              </td>
            </tr>
          ))}

          {/* Grand Total Quantity */}
          <tr className="border-t-2 border-black bg-gray-200">
            <td colSpan="3" className="text-xs font-semibold text-left px-2">
              Grand Total Quantity
            </td>
            <td className="text-xs font-semibold text-right px-2">
              {grandNetTotalQuantity}
            </td>
          </tr>

          {/* Grand Total Sales */}
          <tr className="border-t-2 border-black bg-gray-200">
            <td colSpan="3" className="text-xs font-semibold text-left px-2">
              Grand Total Sales
            </td>
            <td className="text-xs font-semibold text-right px-2">
              {grandNetTotal}
            </td>
          </tr>
        </tbody>
      </table>
    </div>

  </div>
));

export default SalesQuantityReportPDFDocument